const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        // marginTop: "25px"
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        paddingTop: "30px",
        paddingBottom: "20px",
    },
    inputContainer: {
        marginTop: "20px",
    },
    buttonContainer: {
        marginTop: "20px",
        marginBottom: "20px",
    },
});

export default styles;
